import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { exploreCategories as orgConfig } from 'org/configs/modules.config';

/** @type {object} */
const defaultConfig = {
  defaults: {
    categoriesToShow: 6,
    getTitle: (earnType) =>
      (
        <>
          Shop these categories <span className="mn_minor">and</span> earn {earnType}
          <span className="mn_dot">.</span>
        </>
      ),
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
